<template>
  <main class="h-full overflow-auto font-neue" v-if="sub">
    <div v-if="sondage" class="fixed bg-black/50 inset-0 w-full h-full z-50 flex justify-center items-center p-10" >
      <div  class="bg-[#DF2019] text-white shadow p-4 rounded-lg max-w-xl max-h-[90vh] overflow-y-auto relative" >

        <i class="fa-solid fa-xmark absolute top-4 right-4 text-2xl cursor-pointer" @click="sondage = false"></i>
        <h2 class="p-1 text-center font-bold mt-6 mb-6 text-2xl uppercase">Votre avis nous intéressent</h2>
        <div v-if="sondageResult" class="text-center text-2xl font-bold mb-6 my-12">
          Merci d’avoir pris le temps de répondre au sondage !<br> Vos réponses nous aident à nous améliorer.
        </div>
        <Form
        v-else 
        class="px-[9vw] sm:px-4"
        id="cForm"
        form_id="696669f88644bf8a9100467f"
        server="https://api-gabarit.promo.dev"
        v-on:results="getResult"
        v-on:form_submit_loading="onLoading"
        :hideError="hiderror"
        @on_error="showErrorForm"
        :relay="relay"
      />
      </div>
    </div>
    <div>
      <div
        id="status"
        class="bg-[#F3F4F6] middle:p-8 flex flex-wrap justify-center min-h-full text-primary text-gray-600"
      >
        <div
          class="bg-white middle:rounded-xl middle:shadow-lg w-full max-w-7xl"
        >
          <div class="px-4 md:px-8 py-4">
            <p class="py-6 w-full m-auto hidden desktop:block">
              <img
                :src="`https://oxoformdocs.fra1.digitaloceanspaces.com/${op.data._id}/bannerstatut.png`"
                class="w-full"
              />
            </p>
            <p class="py-6 w-full m-auto desktop:hidden">
              <img
                :src="`https://oxoformdocs.fra1.digitaloceanspaces.com/${op.data._id}/banner_statut_mobile.jpeg`"
                class="w-full m-auto self-center object-contain"
              /><!---->
            </p>
            <p class="text-xl sm:text-2xl font-bold text-center pb-8">
              <span class="block sm:inline-block w-48 sm:w-fit m-auto"
                >LES JOURS À CROQUER <a @click="setSondage">FERRERO</a></span
              >
            </p>

            <!---->
            <div class="md:flex md:justify-between flex-wrap">
              <div class="w-full middle:w-[66%]">
                <div class="w-full md:flex md:justify-between md:gap-5">
                  <div
                    class="md:w-96 flex text-white justify-center items-center rounded-lg min-h-full bg-gradient-to-r from-red-700 to-red-500 mb-6 md:mb-0 py-8 pointbloc"
                  >
                    <div>
                      <h3 class="uppercase py-1 text-center">Votre crédit</h3>
                      <span
                        class="block text-5xl font-bold w-full text-center mb-2"
                        >{{ total.toFixed(2).replace('.', ',') }} &euro;
                        <!----></span
                      >
                    </div>
                  </div>
                  <div class="py-4 px-6 gris w-full rounded-lg">
                    <h2 class="title font-bold text-xl">SYNTHESE</h2>
                    <div class="sm:flex sm:justify-between mt-3 mb-4 sm:mb-2">
                      <p>Période de jeu :</p>
                      <p
                        class="text-black"
                        v-if="
                          op &&
                          op.data &&
                          op.data.date_debut &&
                          op.data.date_fin
                        "
                      >
                        Du
                        {{ dayjs(op.data.date_debut).format("DD/MM/YYYY") }} au
                        {{ dayjs(op.data.date_fin).format("DD/MM/YYYY") }}
                      </p>
                    </div>

                    <div
                      class="flex item-center text-blue-500 sm:justify-between mt-2"
                    >
                      <a href="#invoice">Voir le détail des achats déclarées</a>
                    </div>
                  </div>
                </div>
                <h2 class="title mt-10 mb-4 middle:hidden">
                  TÉLÉCHARGEZ VOTRE TICKET DE CAISSE
                </h2>
  
                <UploadView
                  :createLineItemFormId="createLineItemFormId"
                  :subid="realSubId"
                  :formid="updateFormId"
                  :uid="uid"
                  @uploaded="uploaded"
                />
                <div class="block middle:hidden">
                  <div class="pl-2 mb-4">
                    <img
                      :src="`https://oxoformdocs.fra1.digitaloceanspaces.com/${op.data._id}/banner_statut_right.jpeg`"
                      alt="banner"
                      class="w-full desktop:block hidden max-w-sm m-auto"
                    /><!---->
                  </div>
                  <div class="middle:mx-2 p-3 rounded-lg -mt-12 middle:mt-0">
                    <!----><!---->
                    <div class="pb-2"></div>
                    <div class="hidden middle:block">
                      <h3 class="font-semibold mb-2 text-gray-700">
                        Besoin d'aide ?
                      </h3>
                      <p class="text-sm mb-3">
                        N'hésitez pas à nous contacter si vous avez des
                        questions.
                      </p>
                      <a
                        href="/contact"
                        target="_blank"
                        class="text-blue-600 font-semibold cursor-pointer text-sm"
                        >Contactez-nous</a
                      >
                    </div>
                    <div
                      class="hidden middle:block w-[95%] my-6 m-auto border-t border-gray-200"
                    ></div>
                    <div class="hidden middle:block text-sm text-center pb-6">
                      <p>{{ sub.email }}</p>
                      <p class="cursor-pointer">
                        ID : {{ sub._id }}
                        <i class="fa-regular fa-copy ml-2"></i>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-[33%] hidden middle:block">
                <div>
                  <div class="pl-2 mb-4">
                    <img
                      :src="`https://oxoformdocs.fra1.digitaloceanspaces.com/${op.data._id}/banner_statut_right.jpeg`"
                      alt="banner"
                      class="w-full desktop:block hidden max-w-sm m-auto"
                    /><!---->
                  </div>
                  <div class="middle:mx-2 p-3 rounded-lg -mt-12 middle:mt-0">
                    <!----><!---->
                    <div class="pb-2"></div>
                    <div class="hidden middle:block">
                      <h3 class="font-semibold mb-2 text-gray-700">
                        Besoin d'aide ?
                      </h3>
                      <p class="text-sm mb-3">
                        N'hésitez pas à nous contacter si vous avez des
                        questions.
                      </p>
                      <a
                        href="/contact"
                        target="_blank"
                        class="text-blue-600 font-semibold cursor-pointer text-sm"
                        >Contactez-nous</a
                      >
                    </div>
                    <div
                      class="hidden middle:block w-[95%] my-6 m-auto border-t border-gray-200"
                    ></div>
                    <div class="hidden middle:block text-sm text-center pb-6">
                      <p>{{ sub.email }}</p>
                      <p class="cursor-pointer">
                        ID : {{ sub._id }}
                        <i class="fa-regular fa-copy ml-2"></i>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full bg-gray-200 h-[1px]"></div>
          <div data-v-31b7b816="" id="invoice" class="p-8">
            <InvoiceView
              v-if="realSubId && uid"
              :subid="realSubId"
              :opid="op.data._id"
              :uid="uid"
            />
          </div>
          <div class="px-8 py-4 middle:hidden">
            <div>
              <h3 class="font-semibold mb-2 text-gray-700">Besoin d'aide ?</h3>
              <p class="text-sm mb-3">
                N'hésitez pas à nous contacter si vous avez des questions.
              </p>
              <a
                href="/contact"
                target="_blank"
                class="text-blue-600 font-semibold text-sm cursor-pointer"
                >Contactez-nous</a
              >
            </div>
            <div class="w-[95%] my-6 m-auto border-t border-gray-200"></div>
            <div class="text-sm text-center pb-6">
              <p>{{ sub.email }}</p>
              <p>Identifiant : {{ sub._id }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import router from "@/router";
import dayjs from "dayjs";
import axios from "axios";
import { onMounted, ref } from "vue";
import InvoiceView from "@/components/status/InvoiceView.vue";
import UploadView from "@/components/status/UploadView.vue";

const subid = ref(null);
const uid = ref(null);
const realSubId = ref(null);
const sub = ref({});
const total = ref(0);
const op = ref({});
const updateFormId = ref(null);
const createLineItemFormId = ref(null);
const sondage = ref(false);
const sondageResult = ref(false);
const loading = ref(false);
const hiderror = ref(true);
const relay = ref();
const error = ref(false);


const uploaded = () => {
  setTimeout(() => {
    window.location.reload();
  }, 500);
};

const setSondage = () => {
  sondage.value = true;
};

const getResult = (result) => {
  if(result) {
    sondageResult.value = true;
  }
};

const showErrorForm = (event) => {
  alert(event.error.message);
  loading.value = false;
  error.value = true;
};

const onLoading = () => {
  loading.value = true;
};

onMounted(async () => {
  try {
    const currentRoute = router.currentRoute;



    if (currentRoute.params._id && currentRoute.params.uid) {
      // const { data: submission } = await axios.get(
      //   `https://api-gabarit.promo.dev/api/v2/submissions/${currentRoute.params._id}?uid=${currentRoute.params.uid}`
      // );

      const { data: submission } = await axios.get(
        `https://api-gabarit.promo.dev/api/v2/submissions/parentSubmission/${currentRoute.params._id}/${currentRoute.params.uid}`
      );

      if (
        !submission ||
        submission.status == "PERD" ||
        submission.parentSubmissionId
      ) {
        router.push("/");
        return;
      }

      console.log('sub --- ',submission.operationId);

      op.value = await axios.get(
      `https://api-gabarit.promo.dev/api/v2/formdata/${submission.operationId}`
    );
      sub.value = submission;

      // Récupérer l'ID du formulaire UPDATE
      if (op.value.data && op.value.data.forms) {
        const updateForm = op.value.data.forms.find(
          (form) => form.type === "UPDATE" && form.description === "UPDATE"
        );
        if (updateForm) {
          updateFormId.value = updateForm._id;
          console.log('UPDATE Form ID:', updateFormId.value);
        }

        // Récupérer l'ID du formulaire CREATE_LINE_ITEM
        const createLineItemForm = op.value.data.forms.find(
          (form) => form.description === "CREATE_LINE_ITEM"
        );
        if (createLineItemForm) {
          createLineItemFormId.value = createLineItemForm._id;
          console.log('CREATE_LINE_ITEM Form ID:', createLineItemFormId.value);
        }
      }

      // Récupérer les participations enfants et calculer le total des amount_to_refund VALID
      try {
        const { data: facts } = await axios.get(
          `https://api-gabarit.promo.dev/api/operations-custom/platform-v2-invoice/invoices/${submission.operationId}/${submission._id}`
        );

        let totalRefund = 0;
        if (facts && facts.length > 0) {
          facts.forEach((fact) => {
            if (fact.participationValide === "VALID") {
              totalRefund += fact.amount_to_refund || 0;
            }
          });
        }

        // Crédit = 100€ - total des remboursements VALID (en centimes -> euros)
        total.value = Math.round((100 - totalRefund / 100) * 100) / 100;
        if (total.value < 0) {
          total.value = 0;
        }
      } catch (err) {
        console.error('Erreur lors du calcul du crédit:', err);
        total.value = 100;
      }

      subid.value = submission._id;
      uid.value = submission.uid;
      realSubId.value = submission._id;
    }
  } catch (e) {
    console.error(e);
    //  router.push("/");
    return;
  }
});
</script>
